import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon, HEAD_DEFAULT } from '../../common/baseConfig';
import { Radio, Modal, Input, Button, message, Rate } from 'antd';
import moment from 'moment';
import * as actions from './redux/actions';
const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;
function quesTypeName(ID) {
  switch (ID) {
    case 1:
      return '单选题';
    case 2:
      return '多选题';
    case 3:
      return '填空题';
    case 4:
      return '判断题';
    case 5:
      return '问答题';
    case 6:
      return '计算题';
    case 7:
      return '组合题';
    case 8:
      return '多材料组合题';
    case 9:
      return '不定项';
    default:
      break;
  }
}
//1-单选题
function singleQues(props, _checkPars, onhandle) {
  const { data, fontSize } = props;
  if (!data.Body) return '题目内容缺失';
  let myAnswer = data.MyAnswer;
  let Body = {};
  try {
    Body = JSON.parse(data.Body);
  } catch (error) {
    return '题目内容异常';
  }
  let children = [];
  for (const key in Body) {
    if (Body.hasOwnProperty(key)) {
      const element = Body[key];
      children.push({ select: key, title: element });
    }
  }
  return (
    <div className="single-choice">
      <ul>
        {children.map((it, key) => {
          return (
            <li
              className={_checkPars ? 'forbid' : ''}
              key={key}
              onClick={() => {
                if (!_checkPars) {
                  onhandle(it.select);
                }
              }}
            >
              {data.Answer === it.select && _checkPars && (
                <img className="selectImg" src={require('../../images/select.png')} alt="" />
              )}
              <MyIcon
                type={myAnswer === it.select ? 'iconxuanzhong' : 'iconweixuan'}
                className={myAnswer === it.select ? 'radio-active' : 'radio'}
              />
              <p>
                <span style={{ fontSize }}>{it.select}.</span>
                <span
                  style={{ fontSize, marginLeft: 5 }}
                  dangerouslySetInnerHTML={{ __html: it.title }}
                />
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
// 2-多选题
function multipleQues(props, _checkPars, multiMyAnswer, onhandle, onsubmit) {
  const { data, fontSize } = props;
  if (!data.Body) return '题目内容缺失';
  multiMyAnswer = Array.from(multiMyAnswer)
    .sort()
    .join(',');
  let myAnswer = data.MyAnswer || multiMyAnswer || '';
  let Body = JSON.parse(data.Body);
  let children = [];
  for (const key in Body) {
    if (Body.hasOwnProperty(key)) {
      const element = Body[key];
      children.push({ select: key, title: element });
    }
  }
  return (
    <div className="multiple-choice">
      <ul>
        {children.map((it, key) => {
          return (
            <li
              className={_checkPars ? 'forbid' : ''}
              key={key}
              onClick={() => {
                if (!_checkPars) {
                  onhandle(it.select);
                }
              }}
            >
              {data.Answer.indexOf(it.select) !== -1 && _checkPars && (
                <img className="selectImg" src={require('../../images/select.png')} alt="" />
              )}
              <MyIcon
                type={
                  myAnswer.indexOf(it.select) !== -1
                    ? 'iconduoxuankuangxuanzhong'
                    : 'iconduoxuankuang'
                }
                className={myAnswer.indexOf(it.select) !== -1 ? 'checkbox-active' : 'checkbox'}
              />
              <p>
                <span style={{ fontSize }}>{it.select}.</span>
                <span
                  style={{ fontSize, marginLeft: 5 }}
                  dangerouslySetInnerHTML={{ __html: it.title }}
                />
              </p>
            </li>
          );
        })}
      </ul>
      <Button
        disabled={_checkPars}
        type="theme2"
        onClick={() => {
          onsubmit();
        }}
      >
        确定
      </Button>
    </div>
  );
}
//3-填空题
function fillsUpQues(props, _checkPars, fillsUpContent, _onFillsUpChange, _onFillsUpSubmit) {
  const { data } = props;
  if (data.MyAnswer) {
    fillsUpContent = data.MyAnswer;
  }
  return (
    <div className="fills-up">
      <Input
        disabled={_checkPars}
        value={fillsUpContent}
        placeholder="请在此处依次填上答案,用;分割"
        className="fillsUp"
        onChange={e => _onFillsUpChange(e)}
        onBlur={() => _onFillsUpSubmit()}
      />
    </div>
  );
}
// 4-判断题
function trueOrFalseQues(props, _checkPars, onhandle) {
  let { data, fontSize } = props;
  let myAnswer = data.MyAnswer;
  let children = [
    { select: '1', title: '√' },
    { select: '0', title: '×' },
  ];
  return (
    <div className="true-false">
      <ul>
        {children.map((it, key) => {
          return (
            <li
              key={key}
              className={_checkPars ? 'forbid' : ''}
              onClick={() => {
                if (!_checkPars) {
                  onhandle(it.select);
                }
              }}
            >
              {data.Answer === it.select && _checkPars && (
                <img className="selectImg" src={require('../../images/select.png')} alt="" />
              )}
              <MyIcon
                type={myAnswer === it.select ? 'iconxuanzhong' : 'iconweixuan'}
                className={myAnswer === it.select ? 'radio-active' : 'radio'}
              />
              <p>
                <span style={{ fontSize }}>{it.select === '1' ? 'A' : 'B'}.</span>
                <span
                  style={{ fontSize, marginLeft: 5 }}
                  dangerouslySetInnerHTML={{ __html: it.title }}
                />
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
// 5-问答题
function essayQuestion(props, _checkPars, essayContent, _onEssayChange, _onEssaySubmit) {
  const { data } = props;
  if (data.MyAnswer) {
    essayContent = data.MyAnswer;
  }
  return (
    <div className="essay-question">
      <TextArea
        disabled={_checkPars}
        value={essayContent}
        placeholder="请在此处作答"
        className="txtArea"
        onChange={e => _onEssayChange(e)}
        onBlur={() => _onEssaySubmit()}
      />
    </div>
  );
}
export class QuesPane extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    visible: false,
    correctContent: '', //纠错内容
    content: '', //笔记内容
    correctID: -1,
    radio: 0,
    _checkParsIndex: -1,
    _noteIndex: -1,
    _noteListIndex: -1,
    multiMyAnswer: new Set(),
    essayContent: '', //问答题内容
    fillsUpContent: '', //填空题答案
  };

  singleTap(key) {
    const { ID } = this.props.data;
    const { busType, resultId, practiceId, ExamModel, examPaperId } = this.props;
    const { checkParsIndex } = this.props.quesStore;
    let params = {
      busType,
      list: [{ ID: ID, MyAnswer: key }],
      resultId,
    };
    this.props.actions.fetchSubmitQues(params).then(res => {
      if (res.SuccessResponse) {
        if (resultId && practiceId) {
          this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          if (ExamModel === 0) {
            //章节练习模式
            this.props.actions.updateCheckParsIndex({ payload: checkParsIndex.add(ID) });
          }
        }
        if (resultId && examPaperId) {
          this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
        }
      }
    });
  }
  multipleTap(key) {
    const { multiMyAnswer } = this.state;
    if (multiMyAnswer.has(key)) {
      multiMyAnswer.delete(key);
    } else {
      multiMyAnswer.add(key);
    }
    this.setState({
      multiMyAnswer,
    });
  }
  multipleSubmit() {
    const { ID } = this.props.data;
    let { multiMyAnswer } = this.state;
    const { busType, resultId, practiceId, ExamModel, examPaperId } = this.props;
    const { checkParsIndex } = this.props.quesStore;
    if (multiMyAnswer.size <= 0) {
      message.warn('多选题请选择至少一个选项');
      return;
    }
    multiMyAnswer = Array.from(multiMyAnswer)
      .sort()
      .join(',');
    let params = {
      busType,
      list: [{ ID: ID, MyAnswer: multiMyAnswer }],
      resultId,
    };
    this.props.actions.fetchSubmitQues(params).then(res => {
      if (res.SuccessResponse) {
        if (resultId && practiceId) {
          this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          if (ExamModel === 0) {
            //章节练习模式
            this.props.actions.updateCheckParsIndex({ payload: checkParsIndex.add(ID) });
          }
        }
        if (resultId && examPaperId) {
          this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
        }
      }
    });
  }
  trueFalseTap(key) {
    const { ID } = this.props.data;
    const { busType, resultId, practiceId, ExamModel, examPaperId } = this.props;
    const { checkParsIndex } = this.props.quesStore;
    let params = {
      busType,
      list: [{ ID: ID, MyAnswer: key }],
      resultId,
    };
    this.props.actions.fetchSubmitQues(params).then(res => {
      if (res.SuccessResponse) {
        if (resultId && practiceId) {
          this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          if (ExamModel === 0) {
            //章节练习模式
            this.props.actions.updateCheckParsIndex({ payload: checkParsIndex.add(ID) });
          }
        }
        if (resultId && examPaperId) {
          this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
        }
      }
    });
  }
  _onEssayChange(e) {
    this.setState({
      essayContent: e.target.value,
    });
  }
  _onEssaySubmit() {
    const { essayContent } = this.state;
    const { Index, ID } = this.props.data;
    const { busType, resultId, practiceId, ExamModel, examPaperId } = this.props;
    const { checkParsIndex } = this.props.quesStore;
    if (essayContent.trim().length === 0) {
      message.warn(`第${Index + 1}题请填写内容`);
      return;
    }
    let params = {
      busType,
      list: [{ ID: ID, MyAnswer: essayContent }],
      resultId,
    };
    this.props.actions.fetchSubmitQues(params).then(res => {
      if (res.SuccessResponse) {
        if (resultId && practiceId) {
          this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          if (ExamModel === 0) {
            //章节练习模式
            this.props.actions.updateCheckParsIndex({ payload: checkParsIndex.add(ID) });
          }
        }
        if (resultId && examPaperId) {
          this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
        }
      }
    });
  }
  _onFillsUpChange(e) {
    this.setState({
      fillsUpContent: e.target.value,
    });
  }
  _onFillsUpSubmit() {
    const { fillsUpContent } = this.state;
    const { Index, ID } = this.props.data;
    const { busType, resultId, practiceId, ExamModel, examPaperId } = this.props;
    const { checkParsIndex } = this.props.quesStore;
    if (fillsUpContent.trim().length === 0) {
      message.warn(`第${Index + 1}题请填写内容`);
      return;
    }
    let params = {
      busType,
      list: [{ ID: ID, MyAnswer: fillsUpContent }],
      resultId,
    };
    this.props.actions.fetchSubmitQues(params).then(res => {
      if (res.SuccessResponse) {
        if (resultId && practiceId) {
          this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          if (ExamModel === 0) {
            //章节练习模式
            this.props.actions.updateCheckParsIndex({ payload: checkParsIndex.add(ID) });
          }
        }
        if (resultId && examPaperId) {
          this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
        }
      }
    });
  }
  onCollect(ID) {
    const { practiceId, resultId, examPaperId } = this.props;
    this.props.actions
      .fetchAddCollecton({
        BusType: 0,
        BusID: ID,
      })
      .then(res => {
        if (res.SuccessResponse) {
          if (practiceId && resultId) {
            this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
          }
          if (resultId && examPaperId) {
            this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
          }
        }
      });
  }
  submitCorrection() {
    const { radio, correctContent, correctID } = this.state;
    if (radio === 0) {
      message.warn('请选择错误类型');
      return;
    }
    if (correctContent.trim() === '') {
      message.warn('请填写详细内容');
      return;
    }
    this.props.actions
      .fetchAddQuestionerrorCorrection({
        ErrorType: radio,
        Question_ID: correctID,
        Remart: correctContent,
      })
      .then(res => {
        if (res.SuccessResponse) {
          message.success('您的纠错反馈已成功提交！');
          this.setState({
            visible: false,
            correctContent: '',
            radio: 0,
          });
        }
      });
  }
  submitNote(ID, StuID) {
    const { practiceId, resultId, examPaperId } = this.props;
    if (this.state.content.trim() === '') {
      message.warn('笔记内容不能为空');
      return;
    }
    this.props.actions
      .fetchAddQuestionNote({
        Question_ID: ID,
        Remart: this.state.content,
        StuID,
      })
      .then(res => {
        if (res.SuccessResponse) {
          this.setState(
            {
              content: '',
            },
            () => {
              if (practiceId && resultId) {
                this.props.actions.fetchGetQuesChapter({ busId: practiceId, resultId });
              }
              if (resultId && examPaperId) {
                this.props.actions.fetchGetExamPageResult({ busId: examPaperId, resultId });
              }
            },
          );
        }
      });
  }
  onChangeRdo(e) {
    this.setState({
      radio: e.target.value,
    });
  }
  paneDetailLeftRender(MyAnswer, Answer, QuestionType_ID) {
    if (!MyAnswer) {
      return (
        <p className="p1">
          <MyIcon type="icontishi" style={{ color: '#ff9900' }} />
          <span style={{ color: '#ff9900' }}>未作答</span>
        </p>
      );
    }
    if (QuestionType_ID === 1 || QuestionType_ID === 2 || QuestionType_ID === 4) {
      //客观题
      if (MyAnswer !== Answer) {
        return (
          <p className="p1">
            <MyIcon type="iconshanchu" style={{ color: '#f01414' }} />
            <span style={{ color: '#f01414' }}>回答错误</span>
          </p>
        );
      } else {
        return (
          <p className="p1">
            <MyIcon type="icongouxuan" style={{ color: '#42b961' }} />
            <span style={{ color: '#42b961' }}>回答正确</span>
          </p>
        );
      }
    } else {
      //主观题
      return (
        <p className="p1">
          <MyIcon type="icontishi" style={{ color: '#ff9900' }} />
          <span style={{ color: '#ff9900' }}>主观题</span>
        </p>
      );
    }
  }
  render() {
    const { data, index, fontSize } = this.props;
    const studentinfo = JSON.parse(localStorage.getItem('studentinfo'));
    const { fetchAddQuestionerrorCorrectionPending } = this.props.center;
    const { checkParsIndex, checkAllPars } = this.props.quesStore;
    const {
      visible,
      correctContent,
      radio,
      _checkParsIndex,
      _noteIndex,
      _noteListIndex,
      content,
      multiMyAnswer,
      essayContent,
      fillsUpContent,
    } = this.state;
    if (!data) return null;
    const { Title, Content, Answer, MyAnswer } = data;
    let _checkPars = checkAllPars || checkParsIndex.has(data.ID) || false;

    return (
      <div className="ques-store-ques-pane" id={`queStoreQuesPane${index}`}>
        {Content && <div className="ques-content" dangerouslySetInnerHTML={{ __html: Content }} />}
        <h4 style={{ fontSize }}>
          <b>
            {index + 1}.【{quesTypeName(data.QuestionType_ID)}】
          </b>
          <span dangerouslySetInnerHTML={{ __html: Title }}></span>
        </h4>
        {data.QuestionType_ID === 1 &&
          singleQues(this.props, _checkPars, this.singleTap.bind(this))}
        {data.QuestionType_ID === 2 &&
          multipleQues(
            this.props,
            _checkPars,
            multiMyAnswer,
            this.multipleTap.bind(this),
            this.multipleSubmit.bind(this),
          )}
        {data.QuestionType_ID === 3 &&
          fillsUpQues(
            this.props,
            _checkPars,
            fillsUpContent,
            this._onFillsUpChange.bind(this),
            this._onFillsUpSubmit.bind(this),
          )}
        {data.QuestionType_ID === 4 &&
          trueOrFalseQues(this.props, _checkPars, this.trueFalseTap.bind(this))}
        {(data.QuestionType_ID === 5 || data.QuestionType_ID === 6) &&
          essayQuestion(
            this.props,
            _checkPars,
            essayContent,
            this._onEssayChange.bind(this),
            this._onEssaySubmit.bind(this),
          )}
        {_checkPars && (
          <div className="pane-detail">
            <div className="pane-detail-top">
              <div className="pane-detail-left">
                {this.paneDetailLeftRender(MyAnswer, Answer, data.QuestionType_ID)}

                <p className="p2">
                  <span>参考答案:</span>
                  <span>
                    {Answer.length > 15
                      ? '具体看解析'
                      : data.QuestionType_ID !== 4
                      ? Answer
                      : Answer === '1'
                      ? '√'
                      : '×'}
                  </span>
                </p>
                <p className="p3">
                  <span>您的答案:</span>
                  <span>
                    {!MyAnswer
                      ? ''
                      : data.QuestionType_ID !== 4
                      ? MyAnswer
                      : MyAnswer === '1'
                      ? '√'
                      : '×'}
                  </span>
                </p>
              </div>
              <div className="pane-detail-right">
                <p className="p1" onClick={this.onCollect.bind(this, data.ID)}>
                  <MyIcon
                    type="iconshoucang"
                    style={data.IsCollection === 0 ? null : { color: '#ffff00' }}
                  />
                  <span>{data.IsCollection === 0 ? '收藏本题' : '取消收藏'}</span>
                </p>
                <p
                  className="p2"
                  onClick={() =>
                    this.setState({
                      visible: true,
                      correctID: data.ID,
                    })
                  }
                >
                  <MyIcon type="iconbianjiqianbixieshuru2" />
                  <span>纠错</span>
                </p>
                <p
                  className="p3"
                  onClick={() => {
                    if (_checkParsIndex !== -1) {
                      this.setState({
                        _checkParsIndex: -1,
                      });
                    } else {
                      this.setState({
                        _checkParsIndex: data.ID,
                      });
                    }
                  }}
                >
                  <MyIcon type="iconxiala1" className={_checkParsIndex !== -1 ? 'up' : ''} />
                  <span>{_checkParsIndex !== -1 ? '收起解析' : '查看解析'}</span>
                </p>
              </div>
            </div>
            {_checkParsIndex === data.ID && (
              <div className="pane-detail-bottom">
                <div className="level">
                  <span className="tit">试题难度:</span>
                  <Rate disabled defaultValue={data.Level} className="rate" />
                </div>
                <div className="mark">
                  <span className="tit">参考解析:</span>
                  <span dangerouslySetInnerHTML={{ __html: data.Mark ? data.Mark : data.Answer }} />
                </div>
                <div className="doNote">
                  <span className="tit">做题笔记:</span>
                  <Button
                    type="theme2"
                    onClick={() => {
                      if (_noteIndex !== -1) {
                        this.setState({
                          _noteIndex: -1,
                        });
                      } else {
                        this.setState({
                          _noteIndex: data.ID,
                        });
                      }
                    }}
                  >
                    {_noteIndex !== -1 ? '收起' : '记笔记'}
                  </Button>
                </div>
                {_noteIndex === data.ID && (
                  <div className="inputNote">
                    <TextArea
                      value={content}
                      placeholder="请输入笔记内容"
                      className="txtArea"
                      onChange={e => {
                        this.setState({
                          content: e.target.value,
                        });
                      }}
                    />
                    <Button
                      type="theme"
                      onClick={this.submitNote.bind(this, data.ID, studentinfo.StuID)}
                    >
                      提交
                    </Button>
                  </div>
                )}
                <div className="notes">
                  <h2
                    onClick={() => {
                      if (_noteListIndex !== -1) {
                        this.setState({
                          _noteListIndex: -1,
                        });
                      } else {
                        this.setState({
                          _noteListIndex: data.ID,
                        });
                      }
                    }}
                  >
                    <span>{_noteListIndex !== -1 ? '收起所有笔记' : '查看所有笔记'}</span>
                    <span>({data.NoteList.length})</span>
                  </h2>
                  {_noteListIndex === data.ID && (
                    <div className="notesList">
                      {data.NoteList.map(ele => (
                        <div className="note-item" key={ele.ID}>
                          <img src={studentinfo.HeadImg || HEAD_DEFAULT} alt="" />
                          <h3>
                            <p>
                              <span>{studentinfo.Name || '未知'}</span>
                              <span>
                                {moment(new Date(ele.AddTime)).format('YYYY-MM-DD HH:mm:ss')}
                              </span>
                            </p>
                            <p>{ele.Remart}</p>
                          </h3>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        <Modal
          wrapClassName="myNoteModal"
          centered
          maskClosable
          title={null}
          footer={null}
          width={740}
          onCancel={() =>
            this.setState({
              visible: false,
              radio: 0,
              correctContent: '',
            })
          }
          visible={visible}
        >
          <h4>纠错</h4>
          <div className="modal-content">
            <p className="tit">
              一直在完善，从未停歇过，但有些题目可能仍然存在瑕疵，对您造成的不便我们深表歉意
            </p>
            <RadioGroup onChange={this.onChangeRdo.bind(this)} value={radio}>
              <Radio value={1}>含有错别字</Radio>
              <Radio value={2}>答案不正确</Radio>
              <Radio value={3}>题目不完整</Radio>
              <Radio value={4}>图片不存在</Radio>
              <Radio value={5}>解析不正确</Radio>
              <Radio value={6}>其他错误</Radio>
            </RadioGroup>
            <TextArea
              value={correctContent}
              placeholder="请输入详细内容"
              onChange={e => {
                this.setState({
                  correctContent: e.target.value,
                });
              }}
            />
            <div className="btns">
              <Button
                onClick={() => {
                  this.setState({
                    visible: false,
                    radio: 0,
                    correctContent: '',
                  });
                }}
              >
                取消
              </Button>
              <Button
                type="theme"
                onClick={this.submitCorrection.bind(this)}
                loading={fetchAddQuestionerrorCorrectionPending}
              >
                提交
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(QuesPane);



// WEBPACK FOOTER //
// ./src/features/ques-store/QuesPane.js